<template>
  <section class="sectionBackGround">
    <div class="container shape-container d-flex align-items-center">
      <div class="row justify-content-center" style="margin-top: 20px;">
        <div class="col-lg-12">
          <div class="row row-grid">

            <!-- 博客分类侧边栏 -->
            <div class="col-lg-2">
              <card class="border-0 text-center" hover shadow body-classes="py-5">
                <div v-for="category in categories" :key="category.id">
                  <a class="nav-link" href="#" @click="filterByCategory(category.id)" role="button" aria-haspopup="true"
                    aria-expanded="false">
                    {{ category.name }}
                  </a>
                </div>
              </card>
            </div>

            <!-- 博客文章列表和推荐内容 -->
            <div class="col-lg-10" style="background-color: white; padding: 20px; border-radius: 8px;">

              <!--   轮播图部分
  <div id="carousel-focus-captions" class="carousel slide mb-4" data-ride="carousel">
    <ol class="carousel-indicators">
      <li v-for="(image, index) in focusImages" :key="index" :data-target="'#carousel-focus-captions'" :data-slide-to="index" :class="{ active: index === 0 }"></li>
    </ol>
    <div class="carousel-inner">
      <div v-for="(image, index) in focusImages" :key="index" :class="['carousel-item', { active: index === 0 }]">
        <div>
          <img class="d-block w-100" :src="'https://anthromindxx.com/' + image.image" :alt="image.title">
        </div>
      </div>
    </div>
    <a class="carousel-control-prev" href="#carousel-focus-captions" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carousel-focus-captions" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div> -->




              <!-- 博客文章列表 -->
              <div v-for="post in blogPosts" :key="post.id" class="cl-card mb-4">
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-12 cl-card-image img-zoom">
                    <div class="object-responsive object-responsive-4by3">
                      <img :src="'https://anthromindxx.com/ant/blogslt.png' + post.thumb" class="img-fluid thumbnail-img" alt="缩略图">
                    </div>
                  </div>
                  <div class="col-lg-9 col-md-8 col-sm-12 cl-card-main">
                    <h3 class="cl-card-main-title">
                      <a @click.prevent="viewBlogPostDetail(post.id)" href="#">{{ post.title }}</a>
                    </h3>
                    <div class="cl-card-main-info">{{ post.summary }}</div>
                    <div class="cl-card-more">
                      <a @click.prevent="viewBlogPostDetail(post.id)" href="#">阅读更多...</a>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 如果没有文章显示提示 -->
              <div v-if="blogPosts.length === 0" class="text-center text-white mt-5" style="min-height: 300px;">
                <p>没有找到相关的文章，请选择其他分类。</p>
              </div>

              <!-- <base-button tag="a" href="#" type="success" class="mt-4">
                更多
              </base-button> -->
              <!-- 分页控件 -->
              <div class="pagination-controls mt-4 text-center">
                <!-- <button type="button" class="btn mr-2 btn-primary" :disabled="currentPage === 1" @click="previousPage">
                  上一页
                </button>
                <span>{{ currentPage }} / {{ totalPages }}</span>
                <button type="button" class="btn ml-2 btn-primary" :disabled="currentPage === totalPages" @click="nextPage">
                  下一页
                </button> -->
                <nav aria-label="Page navigation example">
                  <ul class="pagination justify-content-center">
                    <li class="page-item disabled" tabindex="-1" @click="previousPage" v-show="currentPage >= 1">
                      <a class="page-link" href="#">
                        <i class="fa fa-angle-left"></i>
                        <span class="sr-only">Previous</span>
                      </a>
                    </li>
                    <li class="page-item active" @click="FunCurrentPage(currentPage)">
                      <a class="page-link" v-show="currentPage <= totalPages">{{ currentPage }}</a>
                    </li>
                    <li class="page-item" @click="FunCurrentPage(currentPage + 1)" v-show="currentPage + 1 <= totalPages">
                      <a class="page-link" href="#">{{ currentPage + 1}}</a>
                    </li>
                    <li class="page-item" @click="FunCurrentPage(currentPage + 2)" v-show="currentPage + 2 <= totalPages">
                      <a class="page-link" href="#">{{ currentPage + 2}}</a>
                    </li>
                    <li class="page-item" @click="nextPage" v-show="!(currentPage === totalPages)">
                      <a class="page-link" href="#">
                        <i class="fa fa-angle-right"></i>
                        <span class="sr-only">Next</span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: "BlogHome",
  data() {
    return {
      categories: [], // 博客分类列表
      blogPosts: [],  // 博客文章列表
      selectedCategory: null, // 当前选择的分类
      isTokenVerified: false,// 用于避免重复验证 token
      currentPage: 1,  // 当前页码
      pageSize: 5,  // 每页显示的文章数
      totalPages: 0,  // 总页数
      carouselImages: [],  // 用于存储从后台获取的轮播图图片数据



    };
  },
  methods: {
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchBlogPosts();
      }
    },
    FunCurrentPage(valPage) {
      this.currentPage = valPage;
      this.fetchBlogPosts();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchBlogPosts();
      }
    },
    async verifyToken() {
      if (this.isTokenVerified) return;
      const token = this.getCookie('token');
      if (!token) {
        alert('Token not found, please login');
        this.$router.push('/login');
        return;
      }

      try {
        const params = new URLSearchParams();
        params.append('token', token);
        const response = await axios.post('https://anthromindxx.com/ca.php?action=verifyToken', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });

        if (response.data.success) {
          this.isTokenVerified = true;
        } else {
         // console.error(response.data.message);
          this.$router.push('/login');
        }
      } catch (error) {
        //console.error('Token verification failed:', error);
        this.$router.push('/login');
      }
    },

    async fetchBlogCategories() {
      if (!this.isTokenVerified) return;  // 如果没有通过 token 验证，阻止请求发送
      const token = this.getCookie('token');
      if (!token) {
        alert('Token not found, please login');
        this.$router.push('/login');
        return;
      }

      try {
        const params = new URLSearchParams();
        params.append('token', token);

        const response = await axios.post('https://anthromindxx.com/ca.php?action=get_blog_categories', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });

        if (response.data.success) {
          this.categories = response.data.categories;
        } else {
          console.error('Error fetching categories:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    },

    async fetchBlogPosts() {
      if (!this.isTokenVerified) return;  // 如果没有通过 token 验证，阻止请求发送
      const token = this.getCookie('token');
      if (!token) {
        alert('Token not found, please login');
        this.$router.push('/login');
        return;
      }

      try {
        const params = new URLSearchParams();
        params.append('token', token);
        if (this.selectedCategory) {
          params.append('category_id', this.selectedCategory);
        }
        params.append('page', this.currentPage);  // 添加页码参数
        params.append('pageSize', this.pageSize); // 添加每页文章数量参数
        const response = await axios.post('https://anthromindxx.com/ca.php?action=get_blog_posts', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });

        if (response.data.success) {
          this.blogPosts = response.data.posts;
          this.totalPages = Math.ceil(response.data.totalPosts / this.pageSize); // 计算总页数

        } else {
          console.error('Error fetching blog posts:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching blog posts:', error);
      }
    },
    async fetchCarouselImages() {
      if (!this.isTokenVerified) return;
      const token = this.getCookie('token');
      if (!token) {
        alert('Token not found, please login');
        this.$router.push('/login');
        return;
      }

      try {
        const params = new URLSearchParams();
        params.append('token', token);

        const response = await axios.post('https://anthromindxx.com/ca.php?action=get_carousel_images', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });

        if (response.data.success) {
          this.carouselImages = response.data.images; // 假设后台返回的图片数据在 `images` 字段中
        } else {
          console.error('Error fetching carousel images:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching carousel images:', error);
      }
    },
    filterByCategory(categoryId) {
      this.selectedCategory = categoryId;
      this.currentPage = 1; // 重置页码为第一页
      this.fetchBlogPosts();
    },
    viewBlogPostDetail(postId) {
      this.$router.push({ name: 'BlogDetail', params: { id: postId } });
    }
  },

  async created() {
    const token = this.getCookie('token');
    if (token) {
      await this.verifyToken();
      if (this.isTokenVerified) {  // 只有通过验证后才获取博客数据
        this.fetchBlogCategories();
        this.fetchBlogPosts();
        this.fetchCarouselImages(); // 调用获取轮播图的函数

      }
    } else {
      this.$router.push('/login');
    }
  }
};
</script>

<style>
.sectionBackGround {
  /* 使内容区域填充剩余空间 */
  min-height: calc(100vh - 48px);
  /* 确保内容区域至少与视口高度减去头部高度一样大 */
  background-image: url('https://anthromindxx.com/ant/bj.jpeg');
  /* 设置背景图路径 */
  background-position: center center;
  /* 背景图片位置 */
  background-attachment: fixed;
  /* 背景图片相对于视口固定 */
  background-size: 100% 100%;
  /* 背景图片根据元素大小缩放 */
  overflow-y: auto;
  /* 在内容较多时显示滚动条 */
}

.carousel-inner img {
  width: 100%;
  height: 270px;
  object-fit: cover;
}

.cl-card {
  margin-bottom: 20px;
}

.cl-card-main-info {
  font-size: 14px;
  color: #666;
}

.cl-card-main-title {
  font-size: 20px;
  font-weight: bold;
}

.cl-card-more a {
  color: #007bff;
  text-decoration: none;
}

.cl-card-image img {
  border-radius: 4px;
}

.thumbnail-img {
  max-width: 150px;
  /* 设置最大宽度 */
  max-height: 150px;
  /* 设置最大高度 */
  object-fit: cover;
  /* 确保图片按比例缩放并裁剪以适应容器 */
  border-radius: 4px;
  /* 圆角效果 */
}

.cl-card {
  background-color: white;
  /* 背景颜色为白色 */
  padding: 15px;
  /* 内边距 */
  border-radius: 8px;
  /* 圆角 */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* 添加轻微的阴影效果 */
}
</style>